
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/goal-planning-lumpsum",
      function () {
        return require("private-next-pages/calculators/goal-planning-lumpsum/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calculators/goal-planning-lumpsum"])
      });
    }
  